import {
    Button,
    Dialog,
    DialogActions,
    DialogBody,
    DialogContent,
    DialogSurface,
    DialogTitle,
} from '@fluentui/react-components';
import { useTranslation } from 'react-i18next';

interface ConfirmDeletionDialogProps {
    open: boolean;
    message: string;
    onConfirm: () => void;
    onClose: () => void;
}

const ConfirmDeletionDialog = ({
    open,
    message,
    onConfirm,
    onClose,
}: ConfirmDeletionDialogProps) => {
    const { t } = useTranslation();

    return (
        <Dialog modalType="alert" open={open}>
            <DialogSurface>
                <DialogBody>
                    <DialogTitle>
                        {t('ConfirmDeletionDialog_Title')}
                    </DialogTitle>
                    <DialogContent>{message}</DialogContent>
                    <DialogActions>
                        <Button appearance="secondary" onClick={onClose}>
                            {t('Dialog_Common_Cancel')}
                        </Button>
                        <Button
                            onClick={() => {
                                if (onConfirm) {
                                    onConfirm();
                                }
                            }}
                            appearance="primary"
                        >
                            {t('Button_Common_Confirm')}
                        </Button>
                    </DialogActions>
                </DialogBody>
            </DialogSurface>
        </Dialog>
    );
};

export default ConfirmDeletionDialog;
